import { apiAuth } from './apiGroup/auth/index'
import { apiDiets } from './apiGroup/diets/index'
import { apiPrices } from './apiGroup/prices/index'
import { apiOrdersGroup } from './apiGroup/orders/index'
import { apiClients } from './apiGroup/clients'
import { apiEmployee } from './apiGroup/apiEmployee'
import { apiLogs } from './apiGroup/apiLogs'
import { apiActivityLogs } from './apiGroup/apiActivityLogs'
import { apiRolesPermissions } from './apiGroup/apiRolesPermissions'
import { apiEmployeeInvites } from './apiGroup/apiEmployeeInvites'
import { apiMedia } from './apiGroup/apiMedia'
import { apiTransactions } from './apiGroup/apiTransactions'
import { apiPromo } from './apiGroup/promotions/index'
import { apiPointsGroup } from './apiGroup/points'
import { apiProduction } from './apiGroup/production'
import { apiEmployees } from './apiGroup/employee'
import { apiSupplier } from './apiGroup/suppliers'
import { apiPurchase } from './apiGroup/purchase'
import { apiWarehousee } from './apiGroup/warehouse'
import { apiFacility } from './apiGroup/facility'
import { apiDemandPlanning } from './apiGroup/demandPlanning'
export const ApiService = {
	...apiAuth,
	...apiEmployee,
	...apiLogs,
	...apiActivityLogs,
	...apiRolesPermissions,
	...apiEmployeeInvites,
	...apiClients,
	...apiDiets,
	...apiPrices,
	...apiMedia,
	...apiOrdersGroup,
	...apiTransactions,
	...apiPromo,
	...apiPointsGroup,
	...apiProduction,
	...apiEmployees,
	...apiSupplier,
	...apiPurchase,
	...apiWarehousee,
	...apiFacility,
	...apiDemandPlanning,
}
